import { render } from "./MobileSidebar.vue?vue&type=template&id=5b300058&scoped=true"
import script from "./MobileSidebar.vue?vue&type=script&lang=js"
export * from "./MobileSidebar.vue?vue&type=script&lang=js"

import "./MobileSidebar.vue?vue&type=style&index=0&id=5b300058&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\stefa\\OneDrive\\Desktop\\utils\\HOLDING SITE\\teilor-holding\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b300058"]])

export default __exports__